import { useMutation } from '@tanstack/react-query'

import type { UpdateApprovalTags } from '../../types/tags'
import api from '../../api'

const useMultiStepApprovalTags = (tagsID: string) => {
	return useMutation({
		mutationFn: async (updateTags: UpdateApprovalTags) => {
			try {
			  let response = await api.tags.updateMultiStepTagsById(updateTags)
				if (!response.ok) {
				  throw new Error(`Status: ${response.status} ${response.statusText} from '/tags'`)
				}
				return response.json()
			}
			catch (error) {
			  throw error
			}
		},
		onSuccess: () => {},
		onError: (error) => {
		  console.log(error)
		}
	})
}

export default useMultiStepApprovalTags
